export default "__VITE_ASSET__86221e5a__"